import welcome from "@assets/images/welcome.png"
import {AuthContainer, AuthDescription, AuthImage, AuthLeftColumn, AuthTitle} from "../styled";
import {ThemesColors} from "@themes/index";
import {ContainerFlexColumn} from "@styled/index";
const Auth = ()=>{
    return (
        <AuthContainer>
            <AuthLeftColumn />
            <AuthDescription>
                <div>
                    <AuthImage src={welcome} alt="welcome" />
                    <AuthTitle color={ThemesColors.popoverBackground}> Your Engine </AuthTitle>
                    </div>
                <ContainerFlexColumn color="linear-gradient(90deg, #31B3EF 0%, #31B3EF 0.01%, #91D5F5 100%)"  gap="5px" items="baseline">
                    <AuthTitle color={ThemesColors.popoverBackground}> for Exellence, </AuthTitle>
                    <AuthTitle color={ThemesColors.gray700}> Your Catalyst </AuthTitle>
                    <AuthTitle color={ThemesColors.gray700}> for Success </AuthTitle>
                </ContainerFlexColumn>
            </AuthDescription>
        </AuthContainer>
    )
}
export default Auth;